const PrimaryDistribution = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">

          <div className="px-1 flex flex-col justify-center lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem]">
            <h1 className="font-bold sm:text-3xl text-2xl text-[#373737]">
              Primary Distribution
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS primary distribution services cater to the inbound logistics processes that help businesses in procurement 
              and the inbound movement of materials, parts, or finished and unfinished inventory from suppliers to deliver 
              them to manufacturing or assembling plants and stores.
              </p>
              <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                Along with an extensive nationwide network, a broad suite of innovative applications enables manufacturers 
                and retailers to monitor and stay on top of their supply chain processes through cloud-based 
                warehouse management systems.
            </p>
           
          </div>
          <div className="flex-1 flex flex-col justify-center items-center">
            <img src="/distribution/Primary-Distribution-Inside.jpg" alt="" className="rounded-md max-w-[100%]"/>
          </div>
        </ div>

      </div>

    </div>
  );
};
  
export default PrimaryDistribution;
  